/* eslint-disable camelcase */
import Axios, { AxiosInstance } from 'axios';

export interface DailyRoomData {
    id: string;
    name: string;
    api_created: boolean;
    privacy: string;
    url: string;
    created_at: Date;
    config: { exp?: number };
}

export class DailyApi {

    private http: AxiosInstance = Axios.create({
        baseURL: 'https://api.daily.co/v1',
        headers: {
            'Accept': 'application/json',
            'Authorization': 'Bearer a2c1fbfa0a8b62d7034723c9a452c6acb730e4e27e50b7544c376e1b227ecae4',
        }
    });

    public async getOrCreateRoom(name: string, exp?: number) {
        // Authorization: Bearer $YOUR_API_KEY
        exp = exp ?? Math.floor(Date.now() / 1000) + 3600;

        return (await this.getRoom(name)) ?? (await this.createRoom(name, exp));

    }

    public async getRoom(name: string): Promise<DailyRoomData | null> {
        return this.http
            .get(`/rooms/${name}`)
            .then(({ data }) => data)
            .catch(() => null);
    }

    private async createRoom(name: string, exp?: number): Promise<DailyRoomData> {
        exp = exp ?? Math.floor(Date.now() / 1000) + 3600;
        const body = {
            name,
            properties: { exp }
        };
        const { data } = await this.http.post('/rooms', body);
        return data;
    }
}
